import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../../contexts/AuthContext';
import { installActivityTracker, setPortalPage } from '../../activityTracker';

// Reports menu/page visits to the backend so they show in Audit Logs → User Activity.
export const ActivityTracker = () => {
  const { pathname } = useLocation();
  const { token, backendUrl, user } = useAuth();
  const lastReported = useRef(null);

  useEffect(() => {
    installActivityTracker();
  }, []);

  useEffect(() => {
    setPortalPage(pathname);
    if (!token) return;
    const key = `${user?.id || 'anon'}|${pathname}`;
    if (lastReported.current === key) return;
    lastReported.current = key;
    axios.post(`${backendUrl}/api/activity/page-view`, { page: pathname }, {
      headers: { Authorization: `Bearer ${token}`, 'X-Portal-Page': pathname }
    }).catch(() => {});
  }, [pathname, token, backendUrl, user]);

  return null;
};

export default ActivityTracker;
